<template>
  <!--
    Menu lateral e o espaço dele vêm do shell `generalPanel`, como no Painel de
    Comunicação. Ver docs/adr/0006-painel-sob-o-shell-da-aplicacao-com-menu.md
  -->
  <cma-dashboard :asset-id="assetId" />
</template>

<script>
import CmaDashboard from '@/domain/components/cma/CmaDashboard';

export default {
  name: 'AssetsViewPanel',
  components: {
    CmaDashboard,
  },
  props: {
    // Vem da URL (ver routes.js, `painel/visao-ativos/:assetId?`) — ausente
    // quando a rota é acessada sem id, aí o CmaDashboard cai no 1º ativo da
    // hierarquia (ver CmaDashboard.vue, loadAssetTree).
    assetId: {
      type: String,
      default: null,
    },
  },
};
</script>
